/**
 * CMP の Shadow DOM ホスト管理
 *
 * バナー/モーダル/リビジットボタンと <style> を格納する単一ホスト
 * <div id="clipkit-cmp"> を body に作り、open shadow root を返す。
 * mode は必ず 'open'（Jest/Capybara-Playwright がセレクタで貫通できるようにするため）。
 */

const HOST_ID = 'clipkit-cmp';

let _host = null;
let _shadowRoot = null;

/**
 * CMP 用の open shadow root を返す（無ければ生成）。
 * ホストが DOM から切り離されている場合は作り直す（Turbo遷移やテストteardown対策）。
 * @returns {ShadowRoot}
 */
export function getShadowRoot() {
  if (_shadowRoot && _host && _host.isConnected) return _shadowRoot;

  // ホストを再生成するのは「呼び出し側が保持する要素参照(_bannerEl等)を既にリセットした後」だけが安全。
  // 現状その経路は _destroy→run のみ（destroyShadowRoot で参照リセット済み）。
  // host を _destroy を経ずに切り離して再描画する経路を将来追加する場合は、要素参照のリセットも必要。
  _host = document.createElement('div');
  _host.id = HOST_ID;
  document.body.appendChild(_host);
  _shadowRoot = _host.attachShadow({ mode: 'open' });
  return _shadowRoot;
}

/**
 * ホストを DOM から除去しキャッシュを破棄する。
 */
export function destroyShadowRoot() {
  if (_host) _host.remove();
  _host = null;
  _shadowRoot = null;
}
